module.exports = new __parcel__URL__("battlepass_xp_component_divider.95311e7a.png").toString();